import { authStateAtom } from "@/orm/auth";
import { useAtomValue } from "jotai";
import { useIsSubscriptionValid } from "./useSubscriptions";

export const useIsPlanInactive = () => {
  const { user } = useAtomValue(authStateAtom);
  const [isActiveSubscription, loadingSubscription] = useIsSubscriptionValid();

  const userCreated = !user?.metadata.creationTime
    ? new Date()
    : new Date(user?.metadata.creationTime);

  const isTrialExpired =
    new Date() > new Date(userCreated.getTime() + 5 * 24 * 60 * 60 * 1000); // 5 day trial

  let isSubscriptionInactive = !isActiveSubscription;
  if (loadingSubscription) isSubscriptionInactive = false;

  let isPlanInactive = isTrialExpired && isSubscriptionInactive;

  if (window.location.href.includes("trial-expired")) isPlanInactive = true;
  if (window.location.href.includes("subscription-expired"))
    isPlanInactive = true;

  const inactiveElementProps = {
    ...(isPlanInactive
      ? { style: { pointerEvents: "none", opacity: 0.3 } }
      : {}),
  } as Partial<React.HTMLAttributes<HTMLDivElement>>;

  // console.log({
  //   isPlanInactive,
  //   isTrialExpired,
  //   isSubscriptionInactive,
  //   loadingSubscription,
  // });

  return {
    isPlanInactive,
    isTrialExpired,
    isSubscriptionInactive,
    inactiveElementProps,
  } as const;
};
